module.exports = __webpack_public_path__ + "static/1-332e6de067b35c79a630cecd340d47d3.jpg";